<script setup lang="ts">
import MultiSelect from 'primevue/multiselect';

type TVariant = 'dark' | 'light';

interface Props {
  variant?: TVariant
  label: string
  placeholder?: string
  errors?: string[]
  options?: {label: string, value: string}[]
}
withDefaults(defineProps<Props>(), {
  variant: 'dark',
});
const id = useId();
const model = defineModel();
</script>

<template>
  <div class="flex flex-col">
    <label for="id" class="font-nutino font-bold text-[16px] text-[#535353] mb-2">{{ label }}</label>
    <MultiSelect
      :class="{'has-errors': errors && errors.length > 0, 'dark-multiselect': variant === 'dark', 'light-multiselect': variant === 'light'}"
      :id="id"
      :showToggleAll="false"
      :options="options"
      v-model="model"
      optionLabel="label"
      optionValue="value"
      :placeholder="placeholder"
      :maxSelectedLabels="3"
      class="w-full custom-multiselect"
      :overlayClass="variant === 'dark' ? 'custom-multiselect dark-multiselect' : 'custom-multiselect light-multiselect'"
      :selectedItemsLabel="$t('mosaic-ui.selectedItems', {count: '{0}'})"
    />
    <span class="text-red-400 text-xs" v-if="errors" v-for="error in errors" v-text="error"></span>
  </div>
</template>

<style lang="scss">
/*:root {
  --p-multiselect-placeholder-color: #fff;
  --p-multiselect-background: #1E1E2A;
  --p-multiselect-border-radius: 20px;
  --p-multiselect-border-color: #5d5d5d;
  --p-multiselect-hover-border-color: #5d5d5d;
  --p-multiselect-focus-border-color: #FFC107;
  --p-multiselect-padding-x: 24px;
  --p-multiselect-padding-y: 18px;
  --p-multiselect-overlay-background: #FFC107;
  --p-multiselect-overlay-border-color: #FFC107;
  --p-multiselect-overlay-border-radius: 20px;
  --p-multiselect-list-padding: 24px;
  --p-checkbox-background: #FFF;
  --p-checkbox-checked-hover-background: #1E1E2A;
  --p-checkbox-checked-background: #1E1E2A;
  --p-checkbox-icon-checked-color: #FFC107;
  --p-checkbox-icon-checked-hover-color: #FFC107;
  --p-checkbox-border-radius: 16px;
  --p-multiselect-color: #fff;
}*/

.p-multiselect.custom-multiselect {
  border-radius: 20px;
  padding: 18px 24px;

  .p-multiselect-label {
    padding: 0;
  }

  &.p-multiselect-open {
    .p-multiselect-dropdown-icon {
      transform: rotate(-180deg);
    }
  }

  .p-multiselect-dropdown {
    margin-right: 14px;
  }
}

.p-multiselect-overlay.custom-multiselect {
  border-radius: 20px;

  .p-multiselect-list-container {
    max-width: calc(100vw - 40px);
    margin-left: 10px;
    margin-right: 10px;

    .p-checkbox {
      margin-left: 10px;
      width: 16px;
      height: 16px;
      border-radius: 5px;

      .p-checkbox-box {
        width: 16px;
        height: 16px;
      }
    }

    .p-multiselect-list {
      padding: 24px;
    }

    .p-multiselect-option {
      gap: 10px;
    }
  }
}

.dark-multiselect.p-multiselect {
  background: #1E1E2A;

  &.has-errors {
    border-color: rgb(248 113 113);
  }
  &:not(.has-errors) {
    border: 1px solid #5d5d5d !important;
  }

  .p-multiselect-label {
    color: #fff;
  }

  &:focus {
    border: 1px solid #FFC107 !important;
  }

  .p-multiselect-dropdown .p-multiselect-dropdown-icon {
      color: #FFC107;
  }
}

.dark-multiselect.p-multiselect-overlay {
  background: #FFC107;
  border-color: #FFC107;

  .p-multiselect-list-container {
    .p-checkbox {
      background: #fff;

      .p-checkbox-box {
        background: #fff;

        svg {
          color: #000;
        }
      }
    }
  }
}

.light-multiselect.p-multiselect {
  background: #FFFFFF;

  &.has-errors {
    border-color: rgb(248 113 113);
  }
  &:not(.has-errors) {
    border: 1px solid #000 !important;
  }

  .p-multiselect-label {
    color: #000;
  }

  &:focus {
    border: 1px solid #000 !important;
  }

  .p-multiselect-dropdown .p-multiselect-dropdown-icon {
    color: #000;
  }
}

.light-multiselect.p-multiselect-overlay {
  background: #FFF;
  border-color: #000;

  .p-multiselect-list-container {
    .p-checkbox-checked:not(.p-disabled):has(.p-checkbox-input:hover) .p-checkbox-box {
      background: #FFC107;
      border: 1px solid #FFC107;
    }

    .p-checkbox {
      background: #fff;

      .p-checkbox-box {
        background: #fff;
        border: 1px solid #FFC107;

        svg {
          color: #000;
        }
      }
    }
  }
}
</style>